import type { HistoryFilter } from '@renderer/overlay/Sidepanel/hooks/use-history-activity'

interface HistorySearchCopy {
  placeholder: string
  /** Shown under the no-results message; null once the whole feed is loaded. */
  truncationHint: string | null
}

interface HistorySearchCopyOptions {
  /** `hasNextPage` — there are history items the client hasn't fetched. */
  hasUnloadedHistory: boolean
}

const PLACEHOLDERS: Record<HistoryFilter, string> = {
  all: 'Search recent history…',
  chat: 'Search recent chats…',
  'audio-note': 'Search recent meetings…',
  'completed-action': 'Search recent actions…',
}

/**
 * What the History view's search field is allowed to claim.
 *
 * Search here is a client-side title match over the pages already fetched, and
 * typing pauses pagination — so the corpus is whatever was loaded when the query
 * started (25 items on a fresh open). Figma's "Find anything in your history…"
 * describes the finished feature, not this one: real Meilisearch search over
 * message bodies, transcripts and summaries is HIG-5837. Until that lands the
 * copy says "recent" and the empty state admits what it didn't look at, so the
 * field promises exactly what it delivers.
 *
 * Restore the Figma copy — and delete this module — with HIG-5837.
 */
export function getHistorySearchCopy(
  filter: HistoryFilter,
  { hasUnloadedHistory }: HistorySearchCopyOptions,
): HistorySearchCopy {
  return {
    placeholder: PLACEHOLDERS[filter],
    truncationHint: hasUnloadedHistory ? 'Older history isn’t searchable yet.' : null,
  }
}
